import React, { useEffect, useState } from 'react'
import {
  Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography
} from '@mui/material'
import {
  MapContainer, TileLayer, Marker, Popup, useMapEvents
} from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

const LocationPicker = ({ open, onClose, onSave, latitute, longitute }) => {
  const [location, setLocation] = useState(null)
  const [mapCenter, setMapCenter] = useState([latitute || 28.457523, longitute || 77.026344])

  // 🗺️ Custom component to set marker on map click
  const LocationMap = () => {
    useMapEvents({
      click(event) {
        setLocation(event.latlng)
      }
    })

    return location ? (
      <Marker
        position={location}
        icon={L.icon({
          iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
        })}
      >
        <Popup>
          Latitude: {location.lat} <br /> Longitude: {location.lng}
        </Popup>
      </Marker>
    ) : null
  }

  // 📍 Handle save
  const handleSave = () => {
    if (onSave && location) {
      onSave(location)
    }
    onClose()
  }

  // 📌 Center map on passed lat/lng when modal opens
  useEffect(() => {
    if (latitute && longitute) {
      const defaultLocation = { lat: latitute, lng: longitute }
      setLocation(defaultLocation)
      setMapCenter([latitute, longitute])
    }
    return () => {
      setLocation(null)
    }
  }, [latitute, longitute])

  const handleUseMyLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords
          const currentLocation = { lat: latitude, lng: longitude }
          setLocation(currentLocation)
          setMapCenter([latitude, longitude])
        },
        (error) => {
          alert('Unable to fetch your location. Please check browser settings or permissions.')
        }
      )
    } else {
      alert('Geolocation is not supported by your browser.')
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Select a Location</DialogTitle>
      <DialogContent>
        <div style={{ height: "400px", width: "100%" }}>
          <MapContainer
            center={mapCenter}
            zoom={17}
            style={{ width: "100%", height: "100%" }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <LocationMap />
          </MapContainer>
        </div>

        <Button
          variant="outlined"
          onClick={handleUseMyLocation}
          style={{ marginTop: '1rem' }}
        >
          Use My Current Location
        </Button>

        {location && (
          <div style={{ marginTop: "20px" }}>
            <Typography variant="h6">Selected Location:</Typography>
            <Typography>Latitude: {location.lat}</Typography>
            <Typography>Longitude: {location.lng}</Typography>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary" disabled={!location}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LocationPicker


// import React, { useEffect, useState } from 'react'
// import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material'
// import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet'
// import L from 'leaflet'
// import 'leaflet/dist/leaflet.css'

// const LocationPicker = ({ open, onClose, onSave, latitute, longitute }) => {
//   const [location, setLocation] = useState(null)

//   // Custom component to handle map click and set lat, lng
//   const LocationMap = () => {
//     useMapEvents({
//       click(event) {
//         setLocation(event.latlng)  // Get lat, lng from the map click event
//       }
//     })


//     return (
//       location && (
//         <Marker position={location} icon={L.icon({
//           iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',  // Leaflet default icon URL
//           iconSize: [25, 41],  // Size of the icon
//           iconAnchor: [12, 41], // Position of the icon anchor (where the marker "sticks" on the map)
//           popupAnchor: [1, -34], // Position of the popup
//         })}>
//           <Popup>
//             Latitude: {location.lat} <br /> Longitude: {location.lng}
//           </Popup>
//         </Marker>
//       )
//     )
//   }

//   const handleSave = () => {
//     if (onSave) {
//       onSave(location);
//     }
//     onClose();
//   };

//   useEffect(() => {
//     setLocation({ lat: latitute, lng: longitute });
//     return () => {
//       setLocation(null)
//     }
//   }, []);

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle>Select a Location</DialogTitle>
//       <DialogContent>
//         <div style={{ height: "400px", width: "100%" }}>
//           <MapContainer
//             center={[latitute || 28.457523, longitute || 77.026344]}
//             zoom={20}
//             style={{ width: "100%", height: "100%" }}
//           >
//             <TileLayer
//               url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             //  url="https://{s}.googleapis.com/maps/vt?x={x}&y={y}&z={z}&scale=1&maptype=roadmap&key=AIzaSyD07E1VvpsN_0FvsmKAj4nK9GnLq-9jtj8"
//             />
//             <LocationMap />
//           </MapContainer>
//         </div>

//         {location && (
//           <div style={{ marginTop: "20px" }}>
//             <Typography variant="h6">Selected Location:</Typography>
//             <Typography>Latitude: {location.lat}</Typography>
//             <Typography>Longitude: {location.lng}</Typography>
//           </div>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} color="primary">
//           Cancel
//         </Button>
//         <Button onClick={handleSave} color="primary" disabled={!location}>
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default LocationPicker
